<template>
  <span>
    <!-- The actual logo component -->
    <component :is="agentTypes[level].icon" class="agent-icon" :class="{ 'agent-icon--small': small, 'agent-icon--large': large }" />
  </span>
</template>

<script>
import BasicAgent from '@/assets/icons/agent-icon-basic.svg'
import SilverAgent from '@/assets/icons/agent-icon-silver.svg'
import GoldAgent from '@/assets/icons/agent-icon-gold.svg'
import PlatinumAgent from '@/assets/icons/agent-icon-platinum.svg'

export default {
  props: {
    level: {
      type: String,
      default: 'EXECUTIVE' // [basic, silver, gold, platinum]
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BasicAgent,
    SilverAgent,
    GoldAgent,
    PlatinumAgent
  },
  data() {
    return {
      agentTypes: {
        EXECUTIVE: { icon: BasicAgent },
        SILVER: { icon: SilverAgent },
        GOLD: { icon: GoldAgent },
        PLATINUM: { icon: PlatinumAgent }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden {
  height: 0;
  width: 0;
}

.agent-icon {
  width: 35px;
  height: 35px;
  vertical-align: middle;

  &--small {
    width: 2rem;
    height: 2rem;
  }

  &--large {
    width: 55px;
    height: 55px;
  }
}
</style>
